module.exports = "<div class=\"container\">\n    <h2 class=\"page-name\"> {{'PAGE_NOT_FOUND' | translate}} </h2>\n</div>\n";